export enum LEVEL {
    ERROR = 'ERROR',
    WARN = 'WARN',
    INFO = 'INFO'
}
